import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';

import { DocumentsService } from '@/openapi';
import { queryKeys } from '@/util/queryKeys';

export const useDocumentLinksQuery = () =>
  useQuery({
    queryKey: queryKeys.documents.links(),
    queryFn: () => DocumentsService.documentsServiceGetDocumentLinks(),
  });

export const useDocumentLinkFolders = () => {
  const { data: externalLinks } = useDocumentLinksQuery();

  const linkFolders = useMemo(() => {
    if (!externalLinks) {
      return new Array<string>();
    }
    const uniqueDirectories = new Set<string>();
    externalLinks.data.forEach((item) =>
      uniqueDirectories.add(item?.folder ?? '/')
    );
    return Array.from(uniqueDirectories);
  }, [externalLinks]);

  return linkFolders;
};
